export default "__VITE_ASSET__DSX2pFjz__"